import { useContext } from "react";
import HeAppWrapper from "../../../components/HeAppWrapper";
import ResponsiveGrid from "../../../layouts/ResponsiveGrid";
import coverPhoto from "../assets/HyaliteWKayak.jpg";
import { actions } from "../context/AppProvider";

import StartScreenContent from "./StartScreenContent";
import Map from "./Map";
import RightPane from "./RightPane";
import MobileMenuItems from "./MobileMenuItems";
import MobileInstructions from "./MobileInstructions";

import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";
import useMountEffect from "../../../hooks/useMountEffect";
import DownloadModal from "./DownloadModal";
import Menu from "./Menu";

const Layout = () => {
    const { screenSize, appHeight, appWidth } = useViewport();
    const { state, dispatch } = useContext(appContext);

    useMountEffect(() => {
        setTimeout(() => {
            dispatch({ type: actions.SET_IS_LOADING, to: false });
        }, 2000);
    });

    return (
        <HeAppWrapper className="app-usfs-indicators fullscreen-app" isLoadingOverlayVisible={state.isMapLoading}>
          <Menu />
            <ResponsiveGrid
                screenSize={screenSize}
                leftSidebarWidth={0}
                rightSidebarWidth={450}
                height={appHeight}
                width={appWidth}
                text_title="U.S. Forest Service Socioeconomic Profile Tool"
                element_leftSidebar={<MobileInstructions />}
                element_rightSidebar={<RightPane />}
                element_mobileMenuItems={<MobileMenuItems />}
                element_main={<Map />}
                element_startScreenContent={<StartScreenContent />}
                startScreenVisible={state.isStartScreenVisible}
                coverPhoto={coverPhoto}
            />
            <DownloadModal />
        </HeAppWrapper>
    );
};
export default Layout;
